import { BOOKING_GA_CATEGORIES, BookingPathKeys } from '../../paths';

export const START_SIGN_IN_STRINGS = {
    OopsOnlyPatientsCanBookAppointments:
        'Oops! Only patients can book appointments.',
    PleaseSignInAsAPatient: 'Please sign in as a patient.',
    SignInPageTitle: "Let's book your appointment!",
    SignInDocumentTitle: 'Zocdoc | Booking | Sign In',
};

export const SIGN_IN_GA_CATEGORY =
    BOOKING_GA_CATEGORIES[BookingPathKeys.startSignInPath];
export const GaActionText = {
    trackMadeItToSignIn: 'Made it to Sign In',
};

export const apiHost = process.env.API_HOST || '';
export const signInEndpoint = `${apiHost}/api/2/web/user/authenticate`;
